import React, { useState } from "react";
import apiClient from "../../../api/axiosConfig.tsx";

const AddListFrame = () => {
  const [file, setFile] = useState<File | null>(null); // Tăng tính an toàn type
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!file) {
      setError("Please select a file to upload");
      return;
    }

    setLoading(true);
    setError("");

    // Tạo formData và thêm file vào
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await apiClient.post(
        "frame/add-frame-by-file",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(
        "File uploaded successfully",
        response?.data?.data?.success?.length
      );
      if (response?.data?.status) {
        alert(response?.data?.message || `Thêm danh sách frame thành công`);
      } else {
        alert(response?.data?.message || `Thêm danh sách frame thành công`);
      }
    } catch (err) {
      console.error("Error uploading file", err);
      setError("Failed to upload file");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="text-2xl text-center text-[pink] font-bold">
        THÊM DANH SÁCH FRAME
      </div>
      <form onSubmit={handleSubmit} className="mb-4 mt-10">
        <input
          type="file"
          accept=".xlsx,.xls"
          onChange={handleFileChange}
          disabled={loading} // Disable khi đang tải lên
        />
        <br />
        <button
          type="submit"
          disabled={loading}
          className="mb-4 bg-[pink] text-white py-2 px-6 rounded-md mt-6"
        >
          {loading ? "Đang thêm..." : "Thêm"}
        </button>
      </form>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default AddListFrame;
